import { Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { PortionMaterialSizeDescriptionField } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

// This section is copied from the ASTM C136 worksheet
let PortionSievingDetailsSection: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  const isWholePortion = namePrefix!.endsWith('WholePortion');
  const isCoarsestSievingPortion = namePrefix!.endsWith('WholePortion.Separation.CoarsePortion');
  const isFineSievingPortion = namePrefix!.endsWith('FinePortion.Subspecimen');
  const isIntermediatePortion = !isCoarsestSievingPortion && namePrefix!.endsWith('CoarsePortion');

  const wholePortionPath = namePrefix?.substr(0, namePrefix.lastIndexOf('.WholePortion') + '.WholePortion'.length);
  const isWholePortionWashed = useSelector(
    pipe(createWorksheetSelector!(`${wholePortionPath}.Washing.IsWashed`, false), valueOrDefault(false))
  );

  const coarsePortionParentPath = namePrefix?.substr(0, namePrefix.lastIndexOf('.Separation.CoarsePortion'));

  return (
    <ListFieldSection>
      <PortionMaterialSizeDescriptionField />
      {isWholePortion && (
        <>
          <Field input={<TextOutput />} label="Specimen Total Dry Mass" name="Masses.DryMass" />
          <Field
            input={<TextOutput />}
            label="Specimen Total Washed Dry Mass"
            name="Washing.WashedDryMass"
            visible={isWholePortionWashed}
          />
        </>
      )}

      {isCoarsestSievingPortion && (
        <>
          <NamePrefixModifier namePrefix={wholePortionPath}>
            <Field input={<TextOutput />} label="Specimen Total Dry Mass" name="Masses.DryMass" />
            <Field
              input={<TextOutput />}
              label="Specimen Total Washed Dry Mass"
              name="Washing.WashedDryMass"
              visible={isWholePortionWashed}
            />
          </NamePrefixModifier>

          <Field input={<TextOutput />} name="Masses.DryMass" label="Sieve Portion Material Dry Mass" />
        </>
      )}

      {isIntermediatePortion && (
        <>
          <NamePrefixModifier namePrefix={coarsePortionParentPath}>
            <Field input={<TextOutput />} label="Subspecimen Total Dry Mass" name="Masses.DryMass" />
          </NamePrefixModifier>
          <Field input={<TextOutput />} name="Masses.DryMass" label="Sieve Portion Material Dry Mass" />
          <Field input={<TextOutput />} name="Masses.MassUpscaleFactor" />
        </>
      )}

      {isFineSievingPortion && (
        <>
          <Field input={<TextOutput />} name="Masses.DryMass" label="Sieve Portion Material Dry Mass" />
          <Field input={<TextOutput />} name="Masses.MassUpscaleFactor" />
        </>
      )}
    </ListFieldSection>
  );
};
PortionSievingDetailsSection = withInjectedProps(PortionSievingDetailsSection);

export { PortionSievingDetailsSection };
export default PortionSievingDetailsSection;
